import React from "react";
import { Badge } from "@ndd/ui";
import type { MetricChip as MetricChipValue } from "../../../../../shared/metrics";
import { CHIP_VARIANTS } from "../../../lib/metrics-display";

export function MetricChip({ chip }: { chip: MetricChipValue }) {
  return (
    <Badge variant={CHIP_VARIANTS[chip]} size="sm">
      {chip}
    </Badge>
  );
}
